// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__3F1_Y","question":"Question_question__3yqc8","description":"Question_description__3VqIz"};